module.exports = __webpack_public_path__ + "308de98e09681636f6f86f0971bfb683.pdf";